import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const confirmationHeading = Loadable(() => import('../../containers/web/confirmationHeading'));
export default MapTo('vcg/components/soe-home/react/confirmationHeading')(confirmationHeading);
